// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";

import MonitoringLevels from "./monitoring-levels";
import type { AbsenceMonitoringLevel } from "@modules/service/reducer/absence-monitoring/types";
import type { AlertShort } from "@modules/shared/reducer/alerts/types";

type OwnProps = $Exact<{
  data: ?Array<AbsenceMonitoringLevel>,
  alerts: ?Array<AlertShort>,
  validationErrors: ?Array<Object>,
  onChange: (data: Array<AbsenceMonitoringLevel>) => void,
  readonly?: boolean,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export const AbsenceMonitoringLevelsForm = (props: Props) => (
  <MonitoringLevels
    levels={props.data}
    alerts={props.alerts}
    onChange={props.onChange}
    readonly={props.readonly}
    validationErrors={props.validationErrors}
  />
);

AbsenceMonitoringLevelsForm.defaultProps = {
  readonly: false,
};

export default localize()(AbsenceMonitoringLevelsForm);
